import { render, staticRenderFns } from "./ai_select.vue?vue&type=template&id=506db5e9&scoped=true"
import script from "./ai_select.vue?vue&type=script&lang=js"
export * from "./ai_select.vue?vue&type=script&lang=js"
import style0 from "./ai_select.vue?vue&type=style&index=0&id=506db5e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506db5e9",
  null
  
)

export default component.exports